import Image from "./Image";
import PDF from "./PDF";

const ContentFile = ({ mime_type, ...props }) => (
    mime_type === 'application/pdf'
        ? <PDF {...props} />
        : <Image {...props} />
);

export default ContentFile;